import { fromBackendDateFormat } from '../../../utils/from-backend-date-format.util';

/**
 * Transaction Date shown for a single issuance row in the Events History ledger.
 *
 * A row with reverse vesting is anchored to its schedule start date rather than the parent event
 * date. Rows without it keep showing the event date.
 *
 * Both are stored as UTC midnight of the day that was picked, so both are read back through
 * `fromBackendDateFormat` — `date-fns` `format` reads local parts, and a bare `new Date` would
 * render the day before the saved one wherever local time is behind UTC.
 *
 * Note this is display only: the backend still filters and orders transactions by the economic
 * `date`, because that is what the cap table and the Events date filter mean. A reverse-vested row
 * can therefore display a date outside the active filter window, and sort by a date other than the
 * one shown.
 *
 * That divergence is accepted product behaviour, not an oversight — reviewed and kept deliberately,
 * because the schedule start date is the date that means something on a reverse-vested row while
 * the economic date is what the cap table is built from. Do not "fix" it by aligning the two
 * without a product decision; changing either side moves what the ledger reports.
 */
export const resolveTransactionDisplayDate = ({
  date,
  reverseVesting,
}: {
  date: Date | number | string;
  reverseVesting?: { startDate: string } | null;
}): Date => fromBackendDateFormat(reverseVesting?.startDate ?? date);
